// extracted by mini-css-extract-plugin
export default {"container":"Title-module__container--NiU4i","anchor":"Title-module__anchor--lijbH","truncate":"Title-module__truncate--PeDFJ","trailingBadges":"Title-module__trailingBadges--K0tM5"};